import { render } from "./CustomersFilterSerie.vue?vue&type=template&id=3ec96d47&scoped=true"
import script from "./CustomersFilterSerie.vue?vue&type=script&lang=js"
export * from "./CustomersFilterSerie.vue?vue&type=script&lang=js"

import "./CustomersFilterSerie.vue?vue&type=style&index=0&id=3ec96d47&lang=scss&scoped=true"
import "./CustomersFilterSerie.vue?vue&type=style&index=1&id=3ec96d47&lang=scss"
import "./CustomersFilterSerie.vue?vue&type=style&index=2&id=3ec96d47&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec96d47"]])

export default __exports__